import * as React from "react";
import { useDropzone } from "react-dropzone";
import { useState, useEffect } from "react";
import { Box, Button, Typography, Tooltip } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {
  UploadFile,
  getDownloadedDocument,
} from "../../../services/FortificationService";
import FileIcon from "../FileIconList/FileIconList";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import useTranslatewrapper from "../../../components/useTranslateWrapper";

export default function FileUpload({
  info,
  callType,
  paths,
  getFileData,
  handleFileDelete,
  setShowButton,
  testDone,
  isMonitor,
  sampleId,
}) {
  const {translate} = useTranslatewrapper();
  const [fileBodys, setFileBodys] = useState([]);
  const dispatch = useDispatch();
  let arrErr = []


  useEffect(() => {
    setFileBodys(paths || []);
  }, [paths]);

  const onDrop = React.useCallback(async (acceptedFileItem) => {
    await Promise.all(
      acceptedFileItem.map(async (file) => {
        const fileUploaded = await UploadFile({file:file}, sampleId);
        if (fileUploaded.status === 200 && fileUploaded.data) {
          setShowButton(true);

          const addEntity = {
            name: callType === "api" ? "" : info.name,
            categoryDocId: callType === "api" ? info.id : "",
            path: fileUploaded?.data,
          };
          setFileBodys((data) => [...data, addEntity]);
          getFileData((data) => [...data, addEntity]);
        }
      })
    );
  }, []);
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  function fileSizeValidation(file) {

    if(file.type !== "application/pdf"){
      arrErr.push("file type should be pdf only");
      dispatchNotification("error", arrErr);
    
      return {
        code: "incorrect-file-type",
        message: `File is not pdf`,
      };
    }

    if (file.size > 1048576) {
      arrErr.push(translate('fileSizeMax1Mb'));
      dispatchNotification("error", arrErr);
    
      return {
        code: "size-too-large",
        message: `File size is larger than 1MB`,
      };
    }
    return null;
  }

  const {
    acceptedFiles: acceptedFileItem,
    fileRejections: rejectedFiles,
    getRootProps: rootPropsFileItem,
    getInputProps: inputPropsFileItem,
    open,
  } = useDropzone({
    onDrop: onDrop,
    validator: fileSizeValidation,
    maxFiles: 10,
    noClick: true,
    multiple: true,
    accept: {
      // "application/msword": [".doc", ".docx"],
      "application/pdf": [".pdf"],
      // "application/msexcel": [".xlsx", ".xml"],
    },
  });

  const handleDelete = (idx, file) => {
    if (Array.isArray(fileBodys)) {
      let data = [...fileBodys];
      data.splice(idx, 1);
      setFileBodys(data);
      handleFileDelete((item) => [...item, file]);
      if (setShowButton) setShowButton(true);
    }
  };
  const handleFileDownload = async (path) => {
    const blob = await getDownloadedDocument(path);

    blob.data && saveAs(blob.data, path);
  };

  return (
    <div>
      <Box
        sx={{ gap: "20px" }}
        {...rootPropsFileItem({ className: "dropzone" })}
      >
        <input disabled={testDone || isMonitor} {...inputPropsFileItem()} />

        <Button
          disabled={testDone || isMonitor}
          variant="outlined"
          color="primary"
          onClick={open}
          sx={{
            height: "auto",
            marginLeft: "0px",
            marginBottom: "0px",
            border: "1px dashed #0075ff",
          }}
        >
          {translate('dragToUpload')}
        </Button>
      </Box>
      {fileBodys && (
        <Typography
          style={{ fontSize: "12px", marginTop: "10px", marginBottom: "1rem" }}
        >
          {Array.isArray(fileBodys) &&
            fileBodys.map((file, idx) => (
              <ListItem
                key={file.path || file.name}
                sx={{
                  height: "30px",
                  width: "85%",
                  padding: "5px 5px",
                  marginLeft: "0px",
                  marginBottom: "0px",
                  border: "1px dashed #0075ff",
                  justifyContent: "space-between",
                  borderRadius: "5px",
                }}
              >
                <FileIcon filename={file.path} />
                <span
                  style={{
                    width: "25ch",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: "#0075ff",
                    textDecoration: "underline",
                  }}
                >
                  {file.path}
                </span>

                <Tooltip
                  title={
                    <Typography sx={{ fontSize: "0.8rem" }}>
                      {translate('download')}
                    </Typography>
                  }
                  placement="top"
                >
                  <Button
                    sx={{ padding: "0px", minWidth: "1px" }}
                    onClick={() => {
                      handleFileDownload(file.path);
                    }}
                  >
                    <FileDownloadOutlinedIcon
                      sx={{ fontSize: "1.2rem", color: "#0075ff" }}
                      m={1}
                    />
                  </Button>
                </Tooltip>

                <Tooltip
                  title={
                    <Typography sx={{ fontSize: "0.8rem" }}>{translate('Remove')}</Typography>
                  }
                  placement="top"
                >
                  <Button
                    disabled={testDone || isMonitor}
                    onClick={() => handleDelete(idx, file)}
                    sx={{ minWidth: "20px" }}
                  >
                    <DeleteOutlineOutlinedIcon
                      sx={{ fontSize: "1.2rem", color: "#0075ff" }}
                    />
                  </Button>

                  {/* <FontAwesomeIcon icon="fa-regular fa-trash-can" /> */}
                </Tooltip>
              </ListItem>
            ))}
        </Typography>
      )}
    </div>
  );
}
